
import { useState } from 'react';
import { Modal } from "react-bootstrap";
import ErrorMessage from 'components/ErrorMessage';
import { HelpAbility } from "helpers/HelpAbility";
import C from "helpers/HelpConstants";
import StockCenter from './StockCenter';

const FORM_CENTER = {
    nombre: '',
    horarioAtencion: '',
    recogerEnPunto: false,
    esCentro: false
}

const FORM = {
    centerId: '',
    stock: '',
    costoEstandar: null,
    costoExpress: null
}
function ProductModal({ modalShow, setModalShow, allCenters, product, linkStockCenter, unlinkStockCenter, message, setMessage, getProduct, getCountProducts }) {

    let myAbilities = HelpAbility();
    const [form, setForm] = useState(FORM)
    const { centerId, stock, costoEstandar, costoExpress } = form;

    const [formCenter, setFormCenter] = useState(FORM_CENTER)


    const handleChange = (e) => {
        console.log("entro aqui:");
        if (e.target.name === "centerId") {
            const center = allCenters.find(center => center._id.toString() === e.target.value)
            console.log("center: ", center);
            if (!center) {
                setFormCenter(FORM_CENTER)
            } else {
                console.log("entro aqui: x2");
                setFormCenter({ ...center })
            }
            setForm({ ...form, [e.target.name]: e.target.value })
        } else {
            console.log(e.target.name, e.target.value);
            setForm({ ...form, [e.target.name]: e.target.value })
        }
    }

    const handleSubmit = async () => {
        let status = await linkStockCenter({ stockCenter: form, id: product._id })
        if (!status) {
            await getProduct({ id: product._id })
            await getCountProducts()
            setFormCenter(FORM_CENTER)
            setForm(FORM)
            setMessage({ message: '', status: 200 })
        }
    }

    if (!modalShow) return null;
    return (
        <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Gestión de Centros
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>Vincular Centro</h6>
                {message.status !== 200 && message.message && <ErrorMessage message={message.message} />}
                <div className="rounded-3 p-3 mb-3" style={{ border: '1px solid black', paddingTop: '15px' }}>
                    <div className="row">
                        <div className="col-3">
                            <div className="mb-3">
                                <label htmlFor="centerId" className="form-label">Código Center</label>
                                <select onChange={handleChange} className="form-select" aria-label="Default select example" name="centerId" value={centerId}>
                                    <option value="">Seleccione</option>
                                    {allCenters.map(center => <option key={center._id} value={center._id}>{center.codigoCentro}</option>)}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="nameCenter" className="form-label">Nombre</label>
                                <input type="text" className="form-control" id="nameCenter" name="nameCenter"
                                    autoComplete="off" disabled
                                    value={formCenter.nombre} />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="mb-3">
                                <label htmlFor="openingHoursCenter" className="form-label">Horario de Atención</label>
                                <input type="text" className="form-control" id="openingHoursCenter" name="openingHoursCenter"
                                    autoComplete="off" disabled
                                    value={formCenter.horarioAtencion} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="pickUpOnPointCenter" className="form-label">Recojo En Punto</label>
                                <div className="row mb-3">
                                    <div className="col">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="pickUpOnPointCenter"
                                                checked={formCenter.recogerEnPunto === true} id="isVisible-radio-true"
                                                value={true} disabled />
                                            <label className="form-check-label" htmlFor="isVisible-radio-true">Si</label>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="pickUpOnPointCenter"
                                                checked={formCenter.recogerEnPunto === false} id="isVisible-radio-false"
                                                value={false} disabled />
                                            <label className="form-check-label" htmlFor="isVisible-radio-false">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="mb-3">
                                <label htmlFor="isCenterCenter" className="form-label">Centro ó Agente</label>
                                <div className="row mb-3">
                                    <div className="col">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="isCenterCenter"
                                                checked={formCenter.esCentro === true} id="isVisible-radio-true"
                                                value={true} disabled />
                                            <label className="form-check-label" htmlFor="isVisible-radio-true">Centro</label>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="isCenterCenter"
                                                checked={formCenter.esCentro === false} id="isVisible-radio-false"
                                                value={false} disabled />
                                            <label className="form-check-label" htmlFor="isVisible-radio-false">Agente</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="stock" className="form-label">Stock</label>
                                <input type="number" className="form-control" id="stock" name="stock"
                                    autoComplete="off" onChange={handleChange}
                                    value={stock} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="stock" className="form-label">C. Estandar</label>
                                <input type="number" className="form-control" id="costoEstandar" name="costoEstandar"
                                    autoComplete="off" onChange={handleChange}
                                    value={costoEstandar} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="stock" className="form-label">C. Express</label>
                                <input type="number" className="form-control" id="costoExpress" name="costoExpress"
                                    autoComplete="off" onChange={handleChange}
                                    value={costoExpress} />
                            </div>
                        </div>
                        <div className="col-3">
                            <button className={'d-block d-block w-100 mb-2 btn btn-success'} type="submit"
                                onClick={handleSubmit}><i className="bi bi-save" />Guardar</button>
                        </div>
                    </div>
                </div>

                <h6>Centros Vinculados</h6>
                <div className="table-responsive rounded-3" style={{ border: '1px solid black' }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col" className="text-center">#</th>
                                <th scope="col" className="text-center">Código</th>
                                <th scope="col" className="text-center">Nombre</th>
                                <th scope="col" className="text-center">Centro/Agente</th>
                                <th scope="col" className="text-center">Stock</th>

                                {myAbilities.has(C.A.CENTER.LINK) &&
                                    <th scope="col" className="text-center">Acción</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                product.stockCenters.length ? product.stockCenters.map((stockCenter, i) =>
                                    <StockCenter
                                        i={i}
                                        key={stockCenter._id}
                                        stockCenter={stockCenter}
                                        unlinkStockCenter={unlinkStockCenter}
                                        getProduct={getProduct}
                                        product={product}
                                        getCountProducts={getCountProducts}
                                    />)
                                    :
                                    <tr>
                                        <td colSpan="5">Sin datos</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>

            </Modal.Body>
        </Modal>
    )
}
export default ProductModal